import React, { useState } from "react";
import { withRouter, useLocation } from "react-router-dom";
import cn from "classnames";
import { useParams } from 'react-router-dom';
import Icon from "../Icon";
import Header from "../Header";
import Sidebar from "../Sidebar";
import styles from "./Page.module.sass";
import NetAPY from "./NetAPY";
import StateUpdater from "./StateUpdater";
import SwitchNetwork from "./SwitchNetwork";
import ChainSupportCloak from "../ChainSupportCloak";
import { _no } from "../../utils";
import Tooltip from "../Tooltip";
import TooltipGlobal from "../TooltipGlobal";

const Page = ({
    wide,
    children,
    title,
    mobileTitle,
    description,
    icon,
    reactIcon
}) => {

    const params = useParams();
    const { pathname } = useLocation();

    const [visible, setVisible] = useState(false);
    const [expand, setExpand] = useState(false);

    const hasHoverInfoList = [
        '/RWAvaults'
    ]

    if (pathname === "/liquid-staking") {
        return (
            <>
                <StateUpdater params={params} />
                <SwitchNetwork />
                {/* <MaintenanceBanner /> */}
                <div className={cn(styles.page, {
                    [styles.expand]: expand
                })}>
                        <Sidebar
                            className={cn(styles.sidebar, { [styles.visible]: visible })}
                            onClose={() => setVisible(false)}
                            onExpand={(expand) => setExpand(expand)}
                        />
                        <Header expand={expand} onOpen={() => setVisible(true)} />
                        <ChainSupportCloak>
                            {children}
                        </ChainSupportCloak>
                </div>
                <TooltipGlobal />
            </>
        );
    }
    
    return (
        <>
            <StateUpdater params={params} />
            <SwitchNetwork />
            {/* <MaintenanceBanner /> */}
            <div className={cn(styles.page, {
                [styles.expand]: expand
            })}>
                <Sidebar
                    className={cn(styles.sidebar, { [styles.visible]: visible })}
                    onClose={() => setVisible(false)}
                    onExpand={(expand) => setExpand(expand)}
                />
                <Header expand={expand} onOpen={() => setVisible(true)} />
                <div className={styles.inner}>
                    <div
                        className={cn(styles.container, {
                            [styles.wide]: wide,
                        })}
                    >
                        <div className={styles.titleContainer}>
                            {(title || mobileTitle) &&
                                <div className={cn("h4", styles.title)}>
                                    {icon ? <Icon name={icon} size="32" /> : reactIcon}
                                    {title && (
                                        <span className={cn(styles.titleText, {
                                            [styles.visible]: _no(mobileTitle)
                                        })}>
                                            {title}
                                        </span>
                                    )}
                                    {mobileTitle && (
                                        <span className={styles.titleMobileText}>
                                            {mobileTitle}
                                        </span>
                                    )}
                                    <Tooltip
                                        title="Real World Assets are regular companies offering revenue sharing to crypto users. RWA businesses are immune to the common security exploits seen in smart contracts, and we have integrated only the most stable and recession-proof opportunities for our users."
                                        place="right"
                                        className={cn(styles.tooltip, {
                                            [styles.hidden]: _no(hasHoverInfoList.includes(pathname))
                                        })}
                                        icon="info"
                                        
                                    />
                                </div>
                            }
                            <div className={styles.netApyContainer}>
                                <NetAPY title={title} />
                            </div>
                        </div>
                        <ChainSupportCloak>
                            {children}
                        </ChainSupportCloak>
                    </div>
                </div>
            </div>
            <TooltipGlobal />
        </>
    );
};

export default withRouter(Page);
